import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=e00efb7e&scoped=true&"
import script from "./Students.vue?vue&type=script&lang=js&"
export * from "./Students.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00efb7e",
  null
  
)

export default component.exports